export default __webpack_public_path__ + "static/november-pro-heavy-bd59abfc1aa2f0b0304d76fc8425abb0.woff2";